import type { App } from 'vue';
import type { ArcoOptions } from '../_utils/types';
import { setGlobalConfig, getComponentPrefix } from '../_utils/global-config';
import _Business from './business.vue';

const Business = Object.assign(_Business, {
  install: (app: App, options?: ArcoOptions) => {
    setGlobalConfig(app, options);
    const componentPrefix = getComponentPrefix(options);

    app.component(componentPrefix + _Business.name, _Business);
  },
});

export type BusinessInstance = InstanceType<typeof _Business>;

export default Business;
